<mat-toolbar class="shell-toolbar">
  <mat-toolbar-row
    [class.top-admin]="isSysadmin || isMlAdmin"
    class="toolbar-grid"
    [class.small-screen-grid]="!(1281 | breakObserver: 'min' | async)">
    <div>
      @if (!isSysadmin && !isMlAdmin) {
        <a (click)="navigateToPage('/')">
          <img src="../../assets/images/logo.svg" />
        </a>
      }
      @if (isSysadmin || isMlAdmin) {
        <img class="top-admin-page" src="../../assets/images/logo.svg" />
      }
    </div>

    <div class="back-to-dashboard">
      @if (backLinkActive) {
        <div class="body-2" (click)="backWithLocation(); jobSearchDialog && jobSearchDialog.closeAll()">
          <mat-icon>chevron_left_24px</mat-icon>
          <span>BACK TO {{ backLinkText }}</span>
        </div>
      }
      <h4 class="display-ellipsis mt-[7px]">{{ pageName }}</h4>
    </div>

    <div class="dashboard-info mt-[8px]" (click)="jobSearchDialog && jobSearchDialog.closeAll()">
      @if (rego) {
        <span class="rego-box subtitle-1">{{ rego }}</span>
      }
      <app-refresh
        (refresh)="routedComponent?.refresh()"
        [cloudState]="toolbarService.cloudState$ | async"
        [loading]="routedComponent?.loading"
        [offline]="!toolbarService.isOnline" />
    </div>

    @if (searchJobsForm) {
      <form class="flex! h-50!" [formGroup]="searchJobsForm" (ngSubmit)="searchJob()">
        @let adminSearchAccess = (isSysadmin || isMlAdmin) && !sysAdminService.repairerSiteAccessed();
        <mat-form-field
          class="global-search-field"
          [ngClass]="{
            'w-[545px]! ml-[15%]!': !adminSearchAccess,
            'w-[655px]! ml-[10%]!': adminSearchAccess
          }"
          [class.small-screen-search]="!(1281 | breakObserver: 'min' | async)">
          <mat-icon matPrefix>search</mat-icon>
          <input
            formControlName="searchInput"
            placeholder="Search by claim number, insurer, REGO,{{
              adminSearchAccess ? ' datafile id, ' : ' '
            }}vehicle or {{ adminSearchAccess ? 'repairer' : 'owner' }}"
            matInput
            #inputSearch />
          @if (searchInput.value) {
            <mat-icon matSuffix class="cursor-pointer" (click)="searchInput.setValue('')">cancel_24px</mat-icon>
          }
        </mat-form-field>
      </form>
    }

    @if (currentUser) {
      <div class="icons" [class.large-screen]="1281 | breakObserver: 'min' | async">
        @if (1281 | breakObserver: 'min' | async) {
          <div class="flex! gap-10 mt-5">
            <div (click)="navigateToPage(backLink)" [class.home-selected]="!backLink" class="home-icon"></div>
            @if (isRepadmin || isRepairer || sysAdminService.repairerSiteAccessed()) {
              <div
                (click)="navigateToPage('/claimList')"
                [class.report-selected]="pageName === 'Claim List'"
                class="report-icon"></div>
            }
            <div
              (click)="navigateToPage('/noticeBoard')"
              [class.notice-board-icon-selected]="pageName === 'Notice Board'"
              class="notice-board-icon"></div>
            <div class="help-icon" [class.button-active]="supportMenuOpened">
              @if (1281 | breakObserver: 'min' | async) {
                <button
                  matIconButton
                  (menuClosed)="supportMenuOpened = false"
                  (menuOpened)="supportMenuOpened = true"
                  (click)="
                    cleanActiveJobHelper.clearSessionStorageFromActiveJob();
                    jobSearchDialog && jobSearchDialog.closeAll()
                  "
                  [matMenuTriggerFor]="supportMenu"></button>
              }
            </div>
            <div class="flex justify-center">
              @if (1281 | breakObserver: 'min' | async) {
                <button
                  matIconButton
                  class="border-[2.5px]! border-solid border-red! rounded-[50%]! size-42! flex justify-center p-0! hover:bg-white! hover:text-charcoal!"
                  (menuClosed)="userMenuOpened = false"
                  (menuOpened)="menuOpened()"
                  (click)="
                    cleanActiveJobHelper.clearSessionStorageFromActiveJob();
                    jobSearchDialog && jobSearchDialog.closeAll()
                  "
                  [class.button-active]="userMenuOpened"
                  [matMenuTriggerFor]="userMenu">
                  <h6>{{ currentUser?.firstName?.charAt(0) }}{{ currentUser?.lastName?.charAt(0) }}</h6>
                </button>
              }
            </div>
          </div>
        }
        @if (!(1281 | breakObserver: 'min' | async)) {
          <button matIconButton [matMenuTriggerFor]="smallMenu" class="flex! menu-icon">
            <mat-icon>menu</mat-icon>
          </button>
        }
        <mat-menu #smallMenu="matMenu" class="menu-dropdown">
          @if (isRepadmin || isRepairer || sysAdminService.repairerSiteAccessed()) {
            <button mat-menu-item (click)="navigateToPage(backLink)">
              <span>Dashboard</span>
            </button>
            <button mat-menu-item (click)="navigateToPage('/claimList')">
              <span>Claim List</span>
            </button>
          }
          <button mat-menu-item (click)="navigateToPage('/noticeBoard')">
            <span>Notice Board</span>
          </button>
          @if (!(1281 | breakObserver: 'min' | async)) {
            <button [matMenuTriggerFor]="supportMenu" (click)="$event.stopPropagation()" mat-menu-item>
              <span>Support</span>
            </button>
          }
          @if (!(1281 | breakObserver: 'min' | async)) {
            <button [matMenuTriggerFor]="userMenu" (click)="$event.stopPropagation()" mat-menu-item>
              <span>User</span>
            </button>
          }
        </mat-menu>
      </div>
    }
  </mat-toolbar-row>
</mat-toolbar>

@if (userService.showRepairerWarningBanner()) {
  <repairer-warning-banner [warning]="userService.repairerWarning()" />
}

<div class="cursor-shell" [class.mouse]="!screenShareStarted()">
  <div class="spot"></div>
  <img src="../../assets/images/arrow.svg" alt="Sys-Admin mouse" />
</div>

<router-outlet (activate)="setRoutedComponent($event)"></router-outlet>

<mat-menu #supportMenu="matMenu" class="p-20!">
  <support-menu-content />
</mat-menu>

<mat-menu #userMenu="matMenu" class="p-20!">
  @if (currentUser?.repairerSiteCompanyName || sysAdminService.repairerSiteAccessed()) {
    <h4>
      {{ currentUser?.repairerSiteCompanyName || sysAdminService.repairerSiteAccessed() }}
    </h4>
  }
  <div class="title body-2">
    {{
      isSysadmin
        ? 'SYSTEM ADMINISTRATOR'
        : isRepadmin
          ? 'ADMINISTRATOR'
          : isMlAdmin
            ? 'REPAIRER ADMINISTRATOR'
            : 'REPAIRER'
    }}
  </div>
  <div class="name">
    {{ currentUserService.currentUserValue?.firstName }} {{ currentUserService.currentUserValue?.lastName }}
  </div>
  <div class="user-email body-2">
    {{ currentUserService.currentUserValue?.email }}
  </div>
  <mat-divider></mat-divider>
  @if (isRepadmin || sysAdminService.repairerSiteAccessed()) {
    <button class="subtitle-1" (click)="navigateToPage('/locationAdmin')" mat-menu-item>Administration</button>
    @if (sysAdminService.estimagePayEnabled()) {
      <button class="subtitle-1" (click)="navigateToPage('/estimagePay')" mat-menu-item>
        <div class="flex items-center gap-x-5">
          EstImage Pay <mat-icon class="size-18! text-18! rounded-[2px]!" svgIcon="estimage_pay" />
        </div>
      </button>
    }
  }
  @if (
    (currentUser?.privileges?.includes('SYSADMIN') || currentUser?.privileges?.includes('MLADMIN')) &&
    currentUserService.currentUserValue?.privileges?.includes('REPADMIN') &&
    sysAdminService.repairerSiteAccessed()
  ) {
    <button class="subtitle-1 h-auto!" (click)="exitRepairerSite()" mat-menu-item>
      Exit {{ sysAdminService.repairerSiteAccessed() }}
    </button>
  }
  @if (isRepadmin || sysAdminService.repairerSiteAccessed()) {
    <button
      mat-menu-item
      class="subtitle-1"
      (click)="navigateToPage('/factoredInvoices/' + userService.repairerSiteId())">
      Factored Invoices
    </button>
  }
  <button class="subtitle-1" (click)="logout()" mat-menu-item>
    <span>Log out</span>
  </button>
  <mat-divider></mat-divider>
  <div class="flex justify-between gap-x-10 pl-5">
    <div class="text-10 text-charcoal-25 w-[170px] leading-[10px]">
      All contents &copy; 1990-{{ currentYear }} Stelvio inc. All rights reserved
    </div>
    <div class="w-[18px]">
      <a href="http://www.stelvio.com" rel="noopener" target="_blank"><img src="../assets/images/stelvio.svg" /> </a>
    </div>
  </div>
</mat-menu>
